import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { SUPPORTED_LANGUAGES } from "./languages";

import en from "../locales/en.json";
import zhCN from "../locales/zh-CN.json";
import vi from "../locales/vi.json";
import th from "../locales/th.json";
import id from "../locales/id.json";
import ko from "../locales/ko.json";
import ja from "../locales/ja.json";
import es from "../locales/es.json";
import pt from "../locales/pt.json";
import ru from "../locales/ru.json";

const resources = {
  en: { translation: en },
  "zh-CN": { translation: zhCN },
  vi: { translation: vi },
  th: { translation: th },
  id: { translation: id },
  ko: { translation: ko },
  ja: { translation: ja },
  es: { translation: es },
  pt: { translation: pt },
  ru: { translation: ru },
} as const;

function convertDetectedLanguage(lng: string): string {
  const l = lng.toLowerCase();
  if (l.startsWith("zh")) return "zh-CN";
  const base = l.split("-")[0];
  if (SUPPORTED_LANGUAGES.includes(base)) return base;
  if (SUPPORTED_LANGUAGES.includes(l)) return l;
  return "en";
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    supportedLngs: [...SUPPORTED_LANGUAGES],
    interpolation: { escapeValue: false },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "gel-locale",
      convertDetectedLanguage,
    },
  });

export default i18n;
